
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { Api } from '@/core/api.js'

import init from './init.json'
const api = new Api()

var lang = window.navigator.userLanguage || window.navigator.language
lang = lang.substr(0, 2)
if (!['en', 'es', 'ca'].includes(lang)) {
  lang = 'en'
}

moment.locale(lang)
moment.updateLocale(lang, {
  calendar: {
    lastDay: '[Ayer]',
    sameDay: '[Hoy]',
    nextDay: '[Mañana]',
    lastWeek: '[El passat] dddd',
    nextWeek: '[La próxima setmana]',
    sameElse: 'dddd, DD [de] MMMM [del] YYYY'
  }
})

Vue.use(VueI18n)

const defaultLocale = 'init'
const languages = {
  init: init
}

const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: lang,
  messages: Object.assign(languages),
  silentTranslationWarn: true
})

i18n.loadLanguageAsync = function (lang2) {
  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      return api.language(lang).then(response => {
        i18n.setLocaleMessage(lang, response)
        loadedLanguages.push(lang)
        return setI18nLanguage(lang)
      })
    }
    return Promise.resolve(setI18nLanguage(lang))
  }
  return Promise.resolve(lang)
}

export default i18n

const loadedLanguages = ['init'] // our default language that is preloaded

function setI18nLanguage (lang2) {
  i18n.locale = lang
  // axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}
